import React, { Component, CSSProperties } from 'react'

import { QuestionMultipleChoiceUniqueAnswerLayout } from '../index'

//@import services
import {I18nUtil} from 'app_utils/i18n'
import { ScreenNotificationsUtil } from 'app_utils/screenNotification'
import { getColorFromCSS } from 'app_utils/functions/getTheme'
//@end

// @import services
import storeService from 'app_services/storeService'
// @end
interface IQuestionMultipleChoiceUniqueAnswerComponentProps {
  questionData: any
  attemptInformation: any
  className?: string
  style?: CSSProperties
  hideButtons?: boolean
  disabled?: boolean
  showCorrect?: boolean
  showMyResponse?: boolean
  validateMyResponse?: boolean
  showFeedback?: boolean
  onSendAnswer: (data: any) => void
  onChange?: (answer: string, question?: string)=>any
}

interface IQuestionMultipleChoiceUniqueAnswerComponentState {
  defaultAnswer: string | null
}

class QuestionMultipleChoiceUniqueAnswerComponent extends Component<
  IQuestionMultipleChoiceUniqueAnswerComponentProps,
  IQuestionMultipleChoiceUniqueAnswerComponentState
> {
  private screenNotification: ScreenNotificationsUtil = new ScreenNotificationsUtil()
  private i18nUtil: I18nUtil = new I18nUtil()

  constructor(props: IQuestionMultipleChoiceUniqueAnswerComponentProps) {
    super(props)
    this.state = {
      defaultAnswer: null,
    }

    this.onNextQuestion = this.onNextQuestion.bind(this)
  }

  componentDidMount() {
    storeService?.subscribe('exercise.currentQuestion', this.handleSubscriptionQuestion)
    storeService?.subscribe('exercise.attemptInformation', this.handleSubscriptionAtttempt)
  }

  componentWillUnmount() {
    storeService?.unsubscribe('exercise.currentQuestion', this.handleSubscriptionQuestion)
    storeService?.unsubscribe('exercise.attemptInformation', this.handleSubscriptionAtttempt)
  }

  handleSubscriptionAtttempt = (data: any) => {
    const attempt = this.props.attemptInformation ? this.props.attemptInformation : data
    if (attempt) {
      this.getAttemptAnswer(attempt, this.props.questionData._id)
    }
  }

  handleSubscriptionQuestion = (data: any) => {
    if (data) {
      this.getAttemptAnswer(this.props.attemptInformation, data._id)
    }
  }

  getAttemptAnswer = (attempt: any, questionId: string) => {
    let answer: string | null = null
    if(attempt && attempt.statistics && Array.isArray(attempt.statistics) && attempt.statistics.length > 0) {
      attempt?.statistics?.map((asn: any) => {
        if (asn.question === questionId) {
          answer = asn.answer
        }
      })
    }

    if (!answer) {
      answer = ''
    }

    this.setState({
      defaultAnswer: answer,
    })
  }

  onNextQuestion = async (answerData: any) => {
    let confirmation: any = {
      isConfirmed: true,
    }
    if (answerData.answer === '') {
      confirmation = await this.screenNotification.fire(
        {
          message: `${this.i18nUtil.getTranslate('resources.questions.empty')}`,
        },
        {
          type: 'warning',
          title: `${this.i18nUtil.getTranslate('resources.questions.send_question')}`,
          confirmButtonText: `${this.i18nUtil.getTranslate('screenNotification.buttons.continue')}`,
          confirmButtonColor: getColorFromCSS('--primary'),
          cancelButtonText: `${this.i18nUtil.getTranslate('screenNotification.buttons.cancel')}`,
          showCancelButton: true,
        },
      )
    }

    if (confirmation.isConfirmed) {
      const dataForResults = {
        answer: answerData.answer,
        question: this.props.questionData._id,
      }
      this.props.onSendAnswer(dataForResults)
    }
  }

  /**
   * @INFO Enviar el evento on change de la pregunta
  */
   public handleSendOnChange = (text: string) => {
    if(this.props.onChange && text.length){
      this.props.onChange(text, this.props.questionData._id)
    }
  }

  render() {
    return <QuestionMultipleChoiceUniqueAnswerLayout
            {...this.props}
            defaultAnswer={this.state.defaultAnswer}
            onNextQuestion={this.onNextQuestion}
            handleSendOnChange={this.handleSendOnChange}
          />
  }
}

export default QuestionMultipleChoiceUniqueAnswerComponent
